// extracted by mini-css-extract-plugin
export var methodRadioContainer = "pages-auth-__TwoFactorAuth-module___methodRadioContainer";
export var radioInput = "pages-auth-__TwoFactorAuth-module___radioInput";
export var radioLabel = "pages-auth-__TwoFactorAuth-module___radioLabel";
export var selected = "pages-auth-__TwoFactorAuth-module___selected";
export var twoFactorIcon = "pages-auth-__TwoFactorAuth-module___twoFactorIcon";
export var twoFactorTooltip = "pages-auth-__TwoFactorAuth-module___twoFactorTooltip";